import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sizeOfString'
})
export class SizeOfStringPipe implements PipeTransform {

  transform(value: string, char: number): SafeHtml  {
   
    
        if(char > 90){
          value=value.slice(0,90) + ' ...';
        }
        // if(char > 90){
        //   value=value.slice(0,90) + ' ...';
        // }
       return value;
    }
  }
 
